import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestScannerResultIgnorePost = {
    path: "/scanner/result/ignore",
    method: RouteHttpVerb.POST
};
export { locationRestScannerResultIgnorePost };
